<button mat-icon-button (click)="fullScreenClick()" aria-label="Fullscreen toggle"
    matTooltip="{{ (isFullscreen() ? 'menu.closeFullScreen' : 'menu.fullScreen') | translate }}">
    <mat-icon>{{ isFullscreen() ? 'close_fullscreen' : 'fullscreen' }}</mat-icon>
</button>